module.exports = __webpack_public_path__ + "static/media/app_notifications.dac35f10.svg";